const TITLE_PREVIEW_LENGTH = 18;

function createAlphabeticDraftSuffix(index: number): string {
  const alphabetLength = 26;
  let value = index;
  let label = '';

  do {
    label = String.fromCharCode(65 + (value % alphabetLength)) + label;
    value = Math.floor(value / alphabetLength) - 1;
  } while (value >= 0);

  return label;
}

export function createPromoDraftLabel(index: number): string {
  return `Promo ${createAlphabeticDraftSuffix(index)}`;
}

function truncatePreview(value: string): string {
  return value.length > TITLE_PREVIEW_LENGTH ? `${value.slice(0, TITLE_PREVIEW_LENGTH)}...` : value;
}

export function formatPromoTitle(draftLabel: string, title: string): string {
  const previewSource = title.trim();
  if (!previewSource) {
    return draftLabel;
  }

  return `${draftLabel} (${truncatePreview(previewSource)})`;
}

export function getNextPromoDraftLabel(items: Array<{ draftLabel: string }>): string {
  const usedLabels = new Set(items.map((item) => item.draftLabel));
  let index = 0;
  let nextLabel = createPromoDraftLabel(index);

  while (usedLabels.has(nextLabel)) {
    index += 1;
    nextLabel = createPromoDraftLabel(index);
  }

  return nextLabel;
}

export function movePromo<T>(items: Array<T>, index: number, offset: -1 | 1): Array<T> {
  const targetIndex = index + offset;
  if (targetIndex < 0 || targetIndex >= items.length) {
    return items;
  }

  const nextItems = [...items];
  [nextItems[index], nextItems[targetIndex]] = [nextItems[targetIndex], nextItems[index]];
  return nextItems;
}
